import { render, staticRenderFns } from "./BillableTab.vue?vue&type=template&id=3b21d8f5&"
import script from "./BillableTab.vue?vue&type=script&lang=js&"
export * from "./BillableTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports